export const DIALOG_Z_INDEX = 2500;

export const UPPER_DIALOG_Z_INDEX = 2501;

export const TIPPY_BOX_Z_INDEX = 1000;

export const BACKDROP_Z_INDEX = 2;
